export default [
    {'id': '1', 'jp': 'どうきょう', 'ko': '도쿄', 'ch': '東京'},
    {'id': '2', 'jp': 'さつぽろ', 'ko': '삿포로', 'ch': ''},
    {'id': '3', 'jp': 'せんだい', 'ko': '센다이', 'ch': ''},
    {'id': '4', 'jp': 'ふくおか', 'ko': '후쿠오카', 'ch': ''},
    {'id': '5', 'jp': 'おおさか', 'ko': '오사카', 'ch': '大阪'},
    {'id': '6', 'jp': 'テニス', 'ko': '테니스', 'ch': ''},
    {'id': '7', 'jp': 'つくる', 'ko': '만들다', 'ch': ''},
    {'id': '8', 'jp': 'デバート', 'ko': '백화점', 'ch': ''},
    {'id': '9', 'jp': 'えいが', 'ko': '영화', 'ch': '映画'},
    {'id': '10', 'jp': 'りょうり', 'ko': '요리', 'ch': ''},
    {'id': '11', 'jp': 'なら', 'ko': '나라', 'ch': ''},
    {'id': '12', 'jp': 'ゆきゅう', 'ko': '야구', 'ch': ''},
    {'id': '13', 'jp': 'びょういん', 'ko': '병원', 'ch': ''},
    {'id': '14', 'jp': 'あさつて', 'ko': '모레', 'ch': ''},
    {'id': '15', 'jp': 'テスト', 'ko': '시험', 'ch': ''},
    {'id': '16', 'jp': 'らいしょう', 'ko': '다음주', 'ch': '来週'},
    {'id': '17', 'jp': 'えき', 'ko': '역', 'ch': '駅'},
    {'id': '18', 'jp': 'どこ', 'ko': '어디', 'ch': ''},
    {'id': '19', 'jp': 'まつすぐ', 'ko': '곧장', 'ch': ''},
    {'id': '20', 'jp': 'ゆうびんきょく', 'ko': '우체국', 'ch': ''},
    {'id': '21', 'jp': 'わたる', 'ko': '건너다', 'ch': ''},
    {'id': '22', 'jp': 'みぎ', 'ko': '오른쪽', 'ch': '右'},
    {'id': '23', 'jp': 'まがる', 'ko': '(방향을) 돌다', 'ch': ''},
    {'id': '24', 'jp': 'おんせん', 'ko': '온천', 'ch': '温泉'},
    {'id': '25', 'jp': 'はなみ', 'ko': '꽃 구경', 'ch': '花見'},
    {'id': '26', 'jp': 'のる', 'ko': '타다', 'ch': '乗る'},
    {'id': '27', 'jp': 'きっぶ', 'ko': '표', 'ch': ''},
    {'id': '28', 'jp': 'まだ', 'ko': '아직', 'ch': ''},
    {'id': '29', 'jp': 'なんだ', 'ko': '~이다', 'ch': ''},
    {'id': '30', 'jp': 'いま', 'ko': '지금', 'ch': '今'},
    {'id': '31', 'jp': 'え？', 'ko': '어?', 'ch': ''},
    {'id': '32', 'jp': 'ちかい', 'ko': '가깝다', 'ch': '近い'},
    {'id': '33', 'jp': 'みち', 'ko': '길', 'ch': '道'},
    {'id': '34', 'jp': 'いちばん', 'ko': '가장', 'ch': ''},
    {'id': '35', 'jp': 'とし', 'ko': '도시', 'ch': 'とし'},
    {'id': '36', 'jp': 'きんざ', 'ko': '긴자', 'ch': ''},
    {'id': '37', 'jp': 'しんじゃい', 'ko': '신주쿠', 'ch': ''},
    {'id': '38', 'jp': 'おだいば', 'ko': '오다이바', 'ch': ''},
    {'id': '39', 'jp': 'など', 'ko': '~등', 'ch': ''},
    {'id': '40', 'jp': 'せかい', 'ko': '세계', 'ch': '世界'},
    {'id': '41', 'jp': 'だくさん', 'ko': '많이', 'ch': ''},
    {'id': '42', 'jp': 'たち', 'ko': '~들', 'ch': ''},
    {'id': '43', 'jp': 'ショッピング', 'ko': '쇼핑', 'ch': ''},
    {'id': '44', 'jp': 'やけい', 'ko': '야경', 'ch': '夜景'},
    {'id': '45', 'jp': 'なのいむ', 'ko': '즐기다', 'ch': '楽しむ'},
    {'id': '46', 'jp': 'じがん', 'ko': '시간', 'ch': '時間'},
    {'id': '47', 'jp': 'すごす', 'ko': '보내다', 'ch': ''},
    {'id': '48', 'jp': 'なんば', 'ko': '난바 (지명)', 'ch': '難波'},
    {'id': '49', 'jp': 'あきはばら', 'ko': '아키하바라', 'ch': '秋葉原'},
    {'id': '50', 'jp': 'かう', 'ko': '사다', 'ch': ''},
    {'id': '51', 'jp': 'つかう', 'ko': '사용하다', 'ch': '使う'},
    {'id': '52', 'jp': 'ソウル', 'ko': '서울', 'ch': ''},
    {'id': '53', 'jp': 'ゲストハウス', 'ko': '게스트 하우스', 'ch': ''},
    {'id': '54', 'jp': 'ユースホステル', 'ko': '\t유스호스텔', 'ch': ''},
    {'id': '55', 'jp': 'ほてる', 'ko': '호텔', 'ch': 'ホテル'},
    {'id': '56', 'jp': 'りょかん', 'ko': '료칸', 'ch': '旅館'},
    {'id': '57', 'jp': 'きよみずでら', 'ko': '기요미즈데라', 'ch': '清水寺'}
]